<cam-calendar
  class="flex-full"
  [planningId]="this.planningId()"
  [events]="this.events()"
  [timeRanges]="this.timeRanges()"
  [cardComponent]="this.cardComponent()"
  [externalEventSourceFeature]="{
    dragRootElement: '#bucket-container',
    dragItemSelector: '.bucket-item',
  }"
  (addEventRequest)="this.eventRequest($event)"
  (updateEventRequest)="this.eventUpdateRequest($event)"
>
  <ng-content></ng-content>
</cam-calendar>
